import React from "react";
import useIsMobile from "../isMobile/IsMobile";
import logo from "../../assets/images/logo1.png";
import insta from "../../assets/images/ins.png";
import linked from "../../assets/images/lin.png";

const FooterComponent = () => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        background: "#000000",
        paddingTop: 50,
        paddingBottom: 50,
        borderTop: "1px solid #5E5E5E",
      }}
      className="w-full"
    >
      {/* Header Text */}
      <div
        style={{
          fontFamily: "Nexa-Bold",
          fontSize: isMobile ? 14 : 20,
          zIndex: 10,
          color: "white",
        }}
        className="flex flex-wrap justify-center text-center"
      >
        Join our community of curious minds and confident communicators today.
      </div>

      {/* Social Links */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 0,
          marginTop: 20,
        }}
      >
        <a
          href="https://www.instagram.com/little___learners?igsh=MWloczVmd21hbmxydg%3D%3D&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div style={{ width: 100 }}>
            <img
              src={insta}
              alt="Instagram"
              style={{ height: "80x", width: "80px", marginRight: -50, cursor: "pointer" }}
            />
          </div>
        </a>
        <a
          href="https://www.linkedin.com/company/little-learner-s/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div style={{ width: 100, marginLeft: -40 }}>
            <img
              src={linked}
              alt="LinkedIn"
              style={{ height: "60px", width: "80px", cursor: "pointer" }}
            />
          </div>
        </a>
      </div>

      {/* Logo + Description */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: isMobile ? 6 : 20,
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        <div>
          <img
            src={logo}
            alt="Logo"
            style={{ height: isMobile ? 100 : 148, width: isMobile ? 100 : 148 }}
          />
        </div>
        <div>
          <div
            style={{
              fontFamily: "Nexa-Bold",
              fontSize: isMobile ? 10 : 16,
              zIndex: 10,
              color: "white",
            }}
          >
            Empowering children through engaging online classes,
          </div>
          <div
            style={{
              fontFamily: "Nexa-Bold",
              fontSize: isMobile ? 10 : 16,
              zIndex: 10,
              color: "white",
            }}
          >
            phonics-based learning, and caring teacher guidance.
          </div>
        </div>
      </div>

      {/* Footer Text */}
      <div
        style={{
          fontFamily: "Nexa-Bold",
          fontSize: isMobile ? 12 : 18,
          zIndex: 10,
          color: "white",
        }}
        className="flex flex-wrap justify-center text-center"
      >
        © 2025 Little Learner’s. All Rights Reserved.
      </div>
    </div>
  );
};

export default FooterComponent;
